<template>
  <div> 
    <full-calendar id="myugcalendar" :options="calendarOptions" />
    <modal-news :news-id="chosenNewsId"></modal-news>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import ModalNews from './modal-news'
import moment from 'moment'
import NewsResource from '../../api/newsResource'

const newsResource = new NewsResource()

export default {
  name: 'calendar',
  components: {
    ModalNews,
    FullCalendar,
  },
  data() {
    return {
      events: [],
      dateRanges: {
        from: moment().subtract(3, 'weeks').format('YYYY-MM-DD'),
        to: moment().add(3, 'weeks').format('YYYY-MM-DD'),
        today: moment().format('YYYY-MM-DD'),
      },
      chosenNewsId: null,
      loading: false,
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        events: [],
        datesSet: null,
        eventClick: null,
      },
    }
  },
  mounted() {
    // Set up event handlers
    this.calendarOptions.datesSet = this.handleDatesSet
    this.calendarOptions.eventClick = this.handleEventClick

    // Initial load
    this.loadEvents(this.dateRanges)
  },
  methods: {
    loadEvents(dateRanges) {
      this.loading = true
      newsResource
        .calendarEvents(dateRanges,this.$i18n.locale)
        .then((response) => {
          this.events = response.data.data
          this.calendarOptions.events = this.events // reactive update
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleDatesSet(arg) {
      const dateRanges = {
        from: moment(arg.start).format('YYYY-MM-DD'),
        to: moment(arg.end).format('YYYY-MM-DD'),
        today: moment().format('YYYY-MM-DD'),
      }
      this.loadEvents(dateRanges)

      // Optional: update button logic here instead of raw DOM
      const currentMonth = moment(arg.start).format('MMMM')
      const prevBtn = document.querySelector('.fc-prev-button')
      if (prevBtn) {
        prevBtn.disabled = currentMonth === 'October'
      }
    },

    handleEventClick(info) {
      if (info.event._def.extendedProps.makeHot==99999) {
        return
      }
      this.chosenNewsId = info.event.id
      this.$bvModal.show('modal-news')
    },
  },
}
</script>

<style >
.fc .fc-daygrid-event .fc-event-title {
  white-space: normal;
  word-break: break-word;
}

/* For timeGrid events (week/day view) */
.fc .fc-timegrid-event .fc-event-title {
  white-space: normal;
  word-break: break-word;
}
</style>
